import { Button, Card, Menu } from 'antd'
import Sider from 'antd/es/layout/Sider'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSideMenu } from '../../contexts/SideMenuContext'
import * as S from './style'
export function SideMenuPublic (): React.ReactElement {
  const { isSideMenuOpen, toggleSideMenu } = useSideMenu()
  const navigate = useNavigate()

  useEffect(() => {
    if (window.innerWidth < 700) toggleSideMenu()
  }, [])

  return <>
    <S.SiderDesktop>
      <Sider
        trigger={null}
        collapsible
        collapsed={!isSideMenuOpen}
        theme='light'
        style={{
          position: 'relative',
          paddingTop: 16,
          boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px'
        }}
      >
        {isSideMenuOpen && (
          <S.BrandContainer>
            <S.Logo />
            <S.BrandTitle>BONBONBABY</S.BrandTitle>
            <S.BrandDescription>Chocolate zero adição de açúcar 🫦✨</S.BrandDescription>
          </S.BrandContainer>
        )}
        <Menu
          style={{ fontFamily: 'var(--font-primary)', display: 'flex', flexDirection: 'column', gap: 8, justifyContent: 'space-between' }}
          theme="light"
          mode="inline"
          items={[]}
        />
        <Card style={{ marginTop: 'auto', fontFamily: 'var(--font-primary)', position: 'relative' }}>
          <Card.Meta
            className=''
            title=''
            description={isSideMenuOpen
              ? <><p style={{ fontSize: '0.75rem' }}>Gostou dessa vitrine de produtos? Descubra como criar a sua com a Forpy.</p>
                <Button
                  style={{ maxWidth: '90%', width: isSideMenuOpen ? '80%' : '60%', margin: '0 auto', marginTop: 8 }}
                  type='primary'
                  icon={<span className="material-symbols-outlined" style={{ fontSize: '1.25rem' }}>arrow_circle_right</span>}
                  onClick={() => navigate('/')}
                  iconPosition='end'
                >
                  {isSideMenuOpen && 'Conheça a Forpy!'}
                </Button>
              </>
              : ''}
          />
        </Card>
        <p className='version-text'></p>
      </Sider>
    </S.SiderDesktop>
    <S.SiderMobile $isSideMenuOpen={isSideMenuOpen}>
      <Sider
        trigger={null}
        collapsible
        collapsedWidth='0px'
        collapsed={!isSideMenuOpen}
        theme='light'
        style={{
          position: 'absolute',
          paddingTop: 16,
          boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
          minHeight: '100vh',
          display: 'flex'
        }}
      >
        <S.BrandContainer>
          <S.Logo />
          <S.BrandTitle>BONBONBABY</S.BrandTitle>
          <S.BrandDescription>Chocolate zero adição de açúcar 🫦✨</S.BrandDescription>
        </S.BrandContainer>
        <Button
          type="text"
          icon={isSideMenuOpen ? <span className="material-symbols-outlined" style={{ fontSize: '1.4rem' }}>close</span> : <span className="material-symbols-outlined" style={{ fontSize: '1.4rem' }}>menu</span>}
          onClick={() => toggleSideMenu()}
          style={{
            width: 32,
            height: 32,
            position: 'absolute',
            top: '16px',
            right: `${isSideMenuOpen ? '16px' : '-49px'}`,
            zIndex: '100',
            background: '#e6f4ff',
            borderRadius: '4px',
            color: 'var(--blue-darker)',
            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px'
          }}
        />
        <Menu
          style={{ fontFamily: 'var(--font-primary)', display: 'flex', flexDirection: 'column', gap: 8, justifyContent: 'space-between' }}
          theme="light"
          mode="inline"
          items={[]}
        />
        <Card style={{ marginTop: 'auto', fontFamily: 'var(--font-primary)', position: 'relative' }}>
          <Card.Meta
            className=''
            title=''
            description={isSideMenuOpen
              ? <><p style={{ fontSize: '0.75rem' }}>Gostou dessa vitrine de produtos? Descubra como criar a sua com a Forpy.</p>
                <Button
                  style={{ maxWidth: '90%', width: isSideMenuOpen ? '100%' : '60%', margin: '8 0 0 16' }}
                  type='primary'
                  icon={<span className="material-symbols-outlined" style={{ fontSize: '1.25rem' }}>arrow_circle_right</span>}
                  onClick={() => navigate('/')}
                  iconPosition='end'
                >
                  {isSideMenuOpen && 'Conheça a Forpy!'}
                </Button>
              </>
              : ''}
          />
        </Card>
        <p className='version-text'></p>
      </Sider>
    </S.SiderMobile>
  </>
}
